import Carousel from "../Carousel/Carousel";
import styles from "./Football.module.css";

const footballData = [
  {
    id: 1,
    img: require("../../assets/images/football-img-1.png"),
    alt: "",
  },
  {
    id: 2,
    img: require("../../assets/images/football-img-2.png"),
    alt: "",
  },
  {
    id: 3,
    img: require("../../assets/images/football-img-3.png"),
    alt: "",
  },
  {
    id: 4,
    img: require("../../assets/images/football-img-4.png"),
    alt: "",
  },
];

const Football = () => {
  return <Carousel title="Football" data={footballData} />;
};

export default Football;
